import { userApi } from "@/core/data/api";

export default async (email) => {
  return await userApi.forgotPassword({ email });
};
